import { del, get, post, toQueryString } from '../axios'
import { paginated, SearchQuery } from '../zod/pagination'
import { webhook, webhookDelivery, webhookWithSecret } from './webhook'
import { z } from 'zod'
import { StoreInput } from './input/store-input'

export function fetchWebhooks(query?: SearchQuery) {
    return get(paginated(webhook), `/webhooks?${toQueryString({ size: 100, ...(query || {}) })}`)
}

export function fetchWebhook(webhookId: string) {
    return get(webhook, `/webhooks/${webhookId}`)
}

export function fetchWebhookDeliveries({ webhookId, query }: { webhookId: string; query?: SearchQuery }) {
    return get(paginated(webhookDelivery), `/webhooks/${webhookId}/deliveries?${toQueryString(query || {})}`)
}

export function createWebhook(input: StoreInput) {
    return post(webhookWithSecret, '/webhooks', input)
}

export function deleteWebhook(webhookId: string) {
    return del(z.object({ message: z.string() }), `/webhooks/${webhookId}`)
}

export function sendTestWebhook(webhookId: string) {
    return post(webhookDelivery, `/webhooks/${webhookId}/test`)
}
